import { Badge, Text } from '@chakra-ui/react';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';

interface ContextNavigationItemProps {
  active: boolean;
  label: string;
  meta?: string;
  metaTone?: 'attention' | 'muted' | 'success';
  navobj: Record<string, unknown>;
  route: string;
}

export function ContextNavigationItem({
  active,
  label,
  meta,
  metaTone = 'muted',
  navobj,
  route,
}: ContextNavigationItemProps) {
  const effectiveMetaTone =
    active && metaTone === 'muted' ? 'attention' : metaTone;

  return (
    <AngularNavLink
      to={route}
      navobj={navobj}
      aria-current={active ? 'page' : undefined}
      variant={active ? 'contextNavigationActive' : 'contextNavigation'}
    >
      <Text noOfLines={1}>{label}</Text>
      {meta && (
        <Badge variant={`navigation-${effectiveMetaTone}`}>{meta}</Badge>
      )}
    </AngularNavLink>
  );
}
